class AjaxLoader {

  constructor() {

    this.postList = document.querySelector(".ajax-post-list");
    this.loadMoreButton = document.querySelector(".post-list-load-more a.btn");
    this.filterButtons = document.querySelectorAll(".filter-button");
    this.filters = document.querySelector('.list-filters');
    if (this.filters) this.filterMode = this.filters.dataset.mode;
    this.selectFilter = document.querySelector('#list-filters-select');

    if (this.filterMode == 'group') {

      if (this.selectFilter) {
        this.selectFilter.addEventListener("change", (e) => {
          this.changeTeamFilter(e.target.value);
        });
      } 

      if (this.filterButtons.length > 0) {
        for (var i = 0; i < this.filterButtons.length; i++) {
          this.filterButtons[i].addEventListener("click", (e) => {
            e.preventDefault();
            this.changeTeamFilter(e.target.dataset.category);
          });
        }
      }
    } else { //if (this.filterMode == 'load-more') {
      
      if (this.postList) {
        let args = this.getArgs(this.postList);
        this.loadPage(args);
  
        this.loadMoreButton.addEventListener("click", (e) => {
          e.preventDefault();
          let newArgs = this.getArgs(this.postList);
          this.loadPage(newArgs);
        });
      
        if (this.selectFilter) {
          this.selectFilter.addEventListener("change", (e) => {
            this.postList.dataset.category = e.target.value;
            this.postList.dataset.next = 1;
            let newArgs = this.getArgs(this.postList);
            document.querySelector(".ajax-post-list .post-list-row").innerHTML = '';
            this.loadPage(newArgs);
          });
        } 
       
        if (this.filterButtons.length > 0) {
          for (var i = 0; i < this.filterButtons.length; i++) {
            this.filterButtons[i].addEventListener("click", (e) => {
              e.preventDefault();
              this.postList.dataset.category = e.target.dataset.category;
              this.postList.dataset.next = 1;
              let newArgs = this.getArgs(this.postList);
              document.querySelector(".ajax-post-list .post-list-row").innerHTML = '';
              this.loadPage(newArgs);
              let activeBtn = document.querySelector('.filter-button.cur');
              if (activeBtn) {
                activeBtn.classList.remove('cur')
              }
              e.target.classList.add('cur')
            });
          }
        }
      }
    }
   // else {
      //Nobody knows
     // console.log('hello')
   // }
    const urlParams = new URLSearchParams(window.location.search);
    const category = urlParams.get('cat');
    if (category && document.querySelector(`.filter-button[data-category="${category}"]`)){
      document.querySelector(`.filter-button[data-category="${category}"]`).click();
    }
  }
  changeTeamFilter(id) {
    let newCat = id;
    let titles = document.querySelectorAll('.title-band');
    let rows = document.querySelectorAll('.team-grid__row, .job-tease');
    let activeBtn = document.querySelector('.filter-button.cur');
    titles.forEach((title) => {
      if (title.dataset.category == newCat || newCat == "") {
        title.classList.remove('d-none');
      }
      else {
        title.classList.add('d-none');
      }
    })
    let hasResults = false;
    rows.forEach((row) => {
      if (row.dataset.category == newCat || newCat == "" || (row.dataset.category.includes(",") && row.dataset.category.split(",").indexOf(newCat) != -1)) {
        row.classList.remove('d-none');
        hasResults = true;
      }
      else {
        row.classList.add('d-none');
      }
    })
    let hasResultsContent = document.querySelector('.careers-has-results');
    let noResultsContent = document.querySelector('.careers-no-results');
    if (hasResultsContent && noResultsContent){
      if (hasResults){
        hasResultsContent.classList.remove('d-none');
        noResultsContent.classList.add('d-none');
      } else {
        hasResultsContent.classList.add('d-none');
        noResultsContent.classList.remove('d-none');
      }
    }
    if (activeBtn) {
      activeBtn.classList.remove('cur')
    }
    document.querySelector(`.filter-button[data-category="${ id }"]`).classList.add('cur');
    this.selectFilter.value = id;
  }
  getArgs(postList) {
    return {
      postList: postList,
      nextPage: postList.dataset.next,
      postType: postList.dataset.type,
      postCat: postList.dataset.category,
      perPage: postList.dataset.perpage
    };
  }
  loadPage (args) {
    var formData = new FormData();

    formData.append("action", "load_more_posts");
    formData.append("page", args.nextPage);
    formData.append("per_page", args.perPage);
    formData.append("post_type", args.postType);
    formData.append("category", args.postCat);

    fetch(`/wp/wp-admin/admin-ajax.php`,{
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then((data) => {

        const postListContainer = document.querySelector(".ajax-post-list"),
  
        row = postListContainer.querySelector(".post-list-row"),
        loadMore = document.querySelector(".post-list-load-more");

      row.innerHTML = row.innerHTML + data.html;

      if (data.nextPage) {
        postListContainer.dataset.next = data.nextPage;
        if (loadMore.classList.contains("d-none"))
          loadMore.classList.remove("d-none");
      } else {
        loadMore.classList.add("d-none");
      }
    });
  }
};

export default new AjaxLoader;
